module.exports = __webpack_public_path__ + "static/media/35-1.5f1fb560.mp3";